import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { signInFacebook } from '../../actions';
import { hideSplash } from '../../actions/splash-actions';

const queryString = require('query-string');

class FacebookLoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mounted: false,
        };
    }

    async componentDidMount() {
        this.setState({ mounted: true });
        const parsed = queryString.parse(this.props.location.hash);
        const state = Buffer.from(parsed?.state?.toString('ascii'), 'base64');
        const { registrationCampaign } = JSON.parse(state);
        await this.props.signInFacebook(parsed.access_token, registrationCampaign);
        if (this.props.auth && this.props.auth.user) {
            this.props.hideSplash();
        }
    }

    render() {
        let redirect = null;
        if (this.props.location.hash) {
            const parsed = queryString.parse(this.props.location.hash);
            const state = Buffer.from(parsed?.state?.toString('ascii'), 'base64');
            const route = JSON.parse(state).sourcePath;
            // the base64 decode makes undefined or null into strings
            if (route !== 'undefined' && route !== 'null') {
                redirect = route;
            }
        }
        const { loading, error, user } = this.props.auth;
        const { mounted } = this.state;

        return (
            <div>
                {mounted && (
                    <div className="container">
                        {loading ? (
                            <div>
                                Signing in...
                            </div>
                        )
                            : (
                                <div>
                                    {error && <div><ReactMarkdown>{`There was an error signing you in: ${error}`}</ReactMarkdown></div>}
                                    {user && <Redirect to={redirect || '/home'} />}
                                </div>
                            )}
                    </div>
                )}
            </div>
        );
    }
}

function mapStateToProps({ auth }) {
    return { auth };
}

function mapDispatchToProps(dispatch) {
    return {
        signInFacebook: (code, registrationCampaign) => dispatch(signInFacebook(code, registrationCampaign)),
        hideSplash: () => dispatch(hideSplash()),
    };
}

const connectedComponent = connect(mapStateToProps, mapDispatchToProps)(FacebookLoginPage);

export default {
    component: withRouter(connectedComponent),
};
